import { PageContainer } from '@/components'
import TaskListMain from '@/pages/threat-protection/task-list/task-list-main'
const TaskList: React.FC = () => (
  <PageContainer>
    <TaskListMain />
  </PageContainer>
)
export default TaskList
